import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getColorsList as getColorsListApi,
    addColorsList as addColorsListApi,
    updateColorsList as updateColorsListApi,
    deleteColorsList as deleteColorsListApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getColorsList = createAsyncThunk("Colors/getColorsList", async () => {
    try {
        const response = await getColorsListApi();
        return response;
    } catch (error) {
        return error;
    }
});
export const addColorsList = createAsyncThunk("Colors/addColorsList", async (category: any) => {
    try {
        const response = addColorsListApi(category);
        const data = await response;
        toast.success("Colors Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Colors Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateColorsList = createAsyncThunk("Colors/update", async (dataArr: any) => {
    try {
        const response = updateColorsListApi(dataArr);
        const data = await response;
        toast.success("Colors Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Colors Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteColorsList = createAsyncThunk("Colors/deleteColorsList", async (categoryId: any) => {
    try {
        const response = deleteColorsListApi(categoryId);
        console.log(response);
        toast.success("Colors Deleted Successfully", { autoClose: 2000 });
        return categoryId;
    } catch (error) {
        toast.error("Colors Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
